import React, { useContext } from 'react';
import { Box, Card, Cards, ResponsiveContext, ThemeContext, Text } from 'grommet';

const appGrid = {
  columns: {
    xsmall: 'auto',
    small: ['auto', 'auto'],
    medium: { count: 'fit', size: ['1/2', 'auto'] },
    large: { count: 'fit', size: ['1/3', 'auto'] },
    xlarge: { count: 'fit', size: ['1/4', 'auto'] },
  },
  rows: 'auto',
  gap: 'medium',
};

// I removed the 'data' prop requirement to prevent the crash
export const ListResults = () => {
  const breakpoint = useContext(ResponsiveContext);
  const theme = useContext(ThemeContext);
  const isDarkMode = theme.dark;
  const isMobile = ['xsmall', 'small'].includes(breakpoint);

  const triggerSoon = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      // 1. Programmatically remove focus to kill the persistent border
      if (e.currentTarget) e.currentTarget.blur();
    }
    window.dispatchEvent(new CustomEvent('show-coming-soon'));
  };

  return (
    <Box gap="medium" pad={{ bottom: 'large' }}>
      <Cards columns={appGrid.columns[breakpoint]} rows={appGrid.rows} gap={appGrid.gap}>
        {/* Assuming 'app' is being passed correctly by your data source. 
           If you were mapping an array, ensure it looks like: {myArray.map((app) => (...))}
        */}
        {(app) => (
          <Card
            key={app.id}
            onClick={triggerSoon}
            // 2. Grommet's specific prop to disable the focus ring
            focusIndicator={false} 
            height={{ min: isMobile ? '160px' : '240px' }}
            style={{
              backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.45)',
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
              border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.4)'}`,
              borderRadius: '16px',
              transition: 'all 0.2s ease-in-out',
              cursor: 'pointer',
              // 3. CSS Safeties
              outline: 'none',
              boxShadow: 'none'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.015)';
              e.currentTarget.style.backgroundColor = isDarkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.6)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.backgroundColor = isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.45)';
            }}
            pad="medium"
          >
            <Box fill="vertical" justify="between" focusable={false}>
              <Box gap="xsmall">
                <Text weight="bold" color="text-strong" size="large">
                  {app.title || "Reference Title"}
                </Text>
                <Text 
                  size="small" 
                  color="text" 
                  style={{ 
                    display: '-webkit-box', 
                    WebkitLineClamp: '3', 
                    WebkitBoxOrient: 'vertical', 
                    overflow: 'hidden' 
                  }}
                >
                  {app.description || "Detailed case study exploring HPE infrastructure."}
                </Text>
              </Box>

              <Box margin={{ top: 'small' }}>
                <Box margin={{ bottom: 'small' }}>
                  <Text size="xsmall" color="text-weak" weight="bold">SOURCE</Text>
                  <Text size="small" color="text-strong" weight="bold" truncate>
                    {app.publisher || "HPE Global"}
                  </Text>
                </Box>

                <Box direction="row" justify="end">
                  <Box 
                    background={isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(1, 169, 130, 0.12)'} 
                    pad={{ horizontal: 'small', vertical: 'xsmall' }} 
                    round="small"
                  >
                    <Text 
                      size="xsmall" 
                      color={isDarkMode ? 'white' : 'brand'} 
                      weight="bold"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      Case Details
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Card>
        )}
      </Cards>
    </Box>
  );
};